import React from 'react'

import { Layout } from 'antd'
import PropTypes from 'prop-types'

import { Search } from '../components'

const Article = (props) => {
  return (
    <React.Fragment>
      <Layout className="container-fluid background-primary">
        <div className="search__header">
          <h1 className="color-secondary">{props.title}</h1>
          <Search allowClear placeholder={props.placeholder} searchtext={props.searchtext} />
        </div>
      </Layout>
      {props.children}
    </React.Fragment>
  )
}

Article.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  searchtext: PropTypes.string,
}

Article.defaultProps = {
  searchtext: '',
}

export default Article
